import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import { IconButton } from '../../atoms';
import { ThemeEnum } from '../../../constants';
export const FileUploadButton = props => {
    const [value, setValue] = useState('');
    const ref = useRef(null);
    const handleChange = (files) => {
        if (files && props.onChange)
            props.onChange(files);
        setValue('');
    };
    return (_jsxs(IconButton, Object.assign({ type: "button", iconClass: "icon-upload", theme: ThemeEnum.Secondary, iconPosition: "left", rounded: true, onClick: () => ref.current && ref.current.click(), disabled: props.disabled }, { children: [props.children, _jsx("input", { value: value, hidden: true, type: "file", name: "formulier", ref: ref, onChange: (e) => e.target.files && handleChange(e.target.files), "aria-label": "Document uploaden" })] })));
};
